import React, {FC, useCallback} from 'react';
import {connect} from 'react-redux';

import {
  KnowledgeBasePlugin,
  KnowledgeBasePluginProps,
} from '../../../libs/knowledge-base/shared/components/plugin/knowledgeBasePlugin';
import {KnowledgeBaseSupportedLanguagesTypesEnum} from '../../../libs/shared/core/src/models/api/knowledgeBaseModel';
import {makeMapStateToProps} from '../../../srcCommon/helpers/reselectHelpers';
import {useAppDispatch} from '../../helpers/appReduxHelpers';
import {
  updatePreferredP4KnowledgeBaseIdAction,
  updatePreferredP4KnowledgeBaseLocaleAction,
} from '../../store/data/localPreferences/localPreferencesActions';
import {
  getPreferredP4KnowledgeBaseId,
  getPreferredP4KnowledgeBaseLocale,
} from '../../store/data/localPreferences/localPreferencesSelectors';

/*
 * Components.
 */

const KnowledgeBasePluginPreferencesContainerComponent: FC<
  Omit<KnowledgeBasePluginProps, 'updatePreferredP4KnowledgeBaseId' | 'updatePreferredP4KnowledgeBaseLocale'>
> = (props) => {
  const dispatch = useAppDispatch();
  const updatePreferredP4KnowledgeBaseId = useCallback(
    (knowledgeBaseId: number) => {
      dispatch(updatePreferredP4KnowledgeBaseIdAction(knowledgeBaseId));
    },
    [dispatch],
  );
  const updatePreferredP4KnowledgeBaseLocale = useCallback(
    (locale: KnowledgeBaseSupportedLanguagesTypesEnum) => {
      dispatch(updatePreferredP4KnowledgeBaseLocaleAction(locale));
    },
    [dispatch],
  );

  return (
    <KnowledgeBasePlugin
      {...props}
      updatePreferredP4KnowledgeBaseId={updatePreferredP4KnowledgeBaseId}
      updatePreferredP4KnowledgeBaseLocale={updatePreferredP4KnowledgeBaseLocale}
    />
  );
};

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps()(() => ({
  preferredKnowledgeBaseId: getPreferredP4KnowledgeBaseId,
  preferredKnowledgeBaseLocale: getPreferredP4KnowledgeBaseLocale,
}));

export const KnowledgeBasePluginPreferencesContainer = connect(mapStateToProps)(
  KnowledgeBasePluginPreferencesContainerComponent,
);
